export default __webpack_public_path__ + "static/media/Rocket-pana.c1831b84.svg";